import { CognitoUser } from 'amazon-cognito-identity-js';
import React from 'react';

import { AUTH_STATES } from 'src/constants/authConsts';
import { RouteContext } from 'src/context';
import { OnboardingAuth } from 'src/legacy/components/Onboarding/Login/OnboardingAuth';
import { OnboardingForgotPasswordPage } from 'src/legacy/components/Onboarding/Login/OnboardingForgotPasswordPage';
import { queryParams } from 'src/legacy/components/Onboarding/Login/OnboardingLoginPage';
import { OnboardingRegisterPage } from 'src/legacy/components/Onboarding/Login/OnboardingRegisterPage';

import { StudioLogin } from './StudioLogin';

export type StudioAuthLayoutProps = {
  onAuthComplete: () => void;
};

interface MfaVerificationData {
  user: CognitoUser;
  email: string;
}

/**
 * Studio-styled internal-user auth shell. Mirrors OnboardingAuthLayout routing
 * (forgot password, invite activation) but uses the unified Studio login for
 * the default sign-in experience.
 */
export const StudioAuthLayout = ({ onAuthComplete }: StudioAuthLayoutProps) => {
  const { query }: { query: queryParams } = React.useContext(RouteContext);
  const { step } = query || '';

  const renderRegisterForm = query.auth && step === AUTH_STATES.SIGN_IN;
  const renderForgotPasswordForm = step === AUTH_STATES.FORGOT_PASSWORD;

  const [mfaData, setMfaData] = React.useState<MfaVerificationData>();

  if (renderRegisterForm) {
    return <OnboardingRegisterPage onAuthComplete={onAuthComplete} />;
  }

  if (mfaData) {
    return (
      <OnboardingAuth
        user={mfaData.user}
        mfaChallengeParam={{
          type: 'SOFTWARE_TOKEN_MFA',
          email: mfaData.email,
        }}
        onAuthComplete={onAuthComplete}
      />
    );
  }

  if (renderForgotPasswordForm) {
    return (
      <OnboardingForgotPasswordPage
        onAuthComplete={onAuthComplete}
        onMfaRequired={(user, email) => {
          setMfaData({ user, email });
        }}
      />
    );
  }

  return <StudioLogin onAuthComplete={onAuthComplete} />;
};
